export { default as productType } from "./productType.yaml";

export const appId = "wx9342fac75eef1111"

export const CDN_URL = "//static.hzwxbz3.cn/Lianyun/font_end/wap";
// ios防下架支付写死的游戏APPKEY
export const GetAppKey = () => {
  const appkey = localStorage.getItem("appkey");
  return appkey
};
const getEnv = function() {
  switch(window.location.hostname) {
    case "webpre.hzwxbz999.cn":
      return "//h5.hzwxbz999.cn"
    case "wap.yuwanc.com":
    case "wap.w2you.com":
    case "wap.bgyxy.com":
      return "//h5.yuwanc.com"
    case "wap-pre.yuwanc.com":
      return "//h5-pre.yuwanc.com"
    default:
      return "//h5.hzwxbz3.cn"
  }
};
export const API_URL = process.env.VUE_APP_IS_TEST ? "//h5.hzwxbz999.cn" : getEnv();
export const QI_DIAN_URL = "//wpa1.qq.com/eqDVsXcI?_type=wpa&qidian=true";
export const QI_DIAN_URL_QQ = "//q.url.cn/CD6n3U?_type=wpa&qidian=true";


export const extra_data = {
  jh_channel: '',
  android_sdk_level: '1',
  android_version: '1',
  device_id: '00000000-0000-0000-0000-000000000000',
  device_name: 'unknown',
  imei: 'unknown',
  ip_addr: '127.0.0.1',
  os: 'android',
  sdk_version: '3.3.6',
  system_proprety: 0,
  wifiname: '<unknown ssid>',
};